/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsLokaliseStringSave,
    ControlcenterMelcoControlCenterModelsLokaliseStringSaveFromJSON,
    ControlcenterMelcoControlCenterModelsLokaliseStringSaveFromJSONTyped,
    ControlcenterMelcoControlCenterModelsLokaliseStringSaveToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsLokaliseStringsSave
 */
export interface ControlcenterMelcoControlCenterModelsLokaliseStringsSave {
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsLokaliseStringSave>}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseStringsSave
     */
    strings?: Array<ControlcenterMelcoControlCenterModelsLokaliseStringSave> | null;
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringsSaveFromJSON(json: any): ControlcenterMelcoControlCenterModelsLokaliseStringsSave {
    return ControlcenterMelcoControlCenterModelsLokaliseStringsSaveFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringsSaveFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsLokaliseStringsSave {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'strings': !exists(json, 'strings') ? undefined : (json['strings'] === null ? null : (json['strings'] as Array<any>).map(ControlcenterMelcoControlCenterModelsLokaliseStringSaveFromJSON)),
    };
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringsSaveToJSON(value?: ControlcenterMelcoControlCenterModelsLokaliseStringsSave | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'strings': value.strings === undefined ? undefined : (value.strings === null ? null : (value.strings as Array<any>).map(ControlcenterMelcoControlCenterModelsLokaliseStringSaveToJSON)),
    };
}


